import { render, staticRenderFns } from "./EmailResetPasswordView.vue?vue&type=template&id=2c1e0f6e"
import script from "./EmailResetPasswordView.vue?vue&type=script&lang=js"
export * from "./EmailResetPasswordView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports